import { USER_TYPE } from "../classes/Enum"
import { STATE } from "../classes/Enum"

const LoginRegisterCartComponent = ({setState}) => {
    return <div>
        <button onClick={() => setState(STATE.PROFILE)}>
            <h3>Use Existing</h3>
            <img src="/assets/svgs/person.svg"></img>
        </button>
    </div>
}

export default LoginRegisterCartComponent